import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_PREFIX = 'listReturn.';

/**
 * Called by a list page: remembers its URL with the filters, for this browser tab,
 * so its detail and form pages go back to the same filtered list.
 */
export const useRememberListUrl = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + pathname, `${pathname}${search}`);
    } catch {
      // Returning to the filtered list is a convenience; without storage "back" opens the plain list
    }
  }, [pathname, search]);
};

/** Where "back" to a list goes: the list with the filters last used in this tab, or the plain list */
export const listReturnUrl = (listPath: string): string => {
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + listPath) ?? listPath;
  } catch {
    return listPath;
  }
};
